import { ErrorMessage } from "@hookform/error-message";
import { useEffect, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import AsyncSelect from 'react-select/async';
import { Col, Row } from "reactstrap";
import { GET } from "../../../helper/api";

const SearchBill = () => {
  const { control, errors, watch } = useFormContext();
  const [selectedData, setSelectedData] = useState();
  const billId = watch('billId')
  const searchBillTimeOut = useRef();
  const onSearchBill = (inputValue) => {
    inputValue = (inputValue || '').trim()
    if (searchBillTimeOut.current) {
      clearTimeout(searchBillTimeOut.current)
    }
    return new Promise(resolve => {
      searchBillTimeOut.current = setTimeout(() => {
        GET('/bill/search-bill', {
          ...(inputValue ? { search: inputValue } : {})
        }, true)
          .then(({ data }) => {
            const options = data.map((e) => ({
              label: e.id,
              value: e.id,
              data: e
            }))
            resolve(options)
          })
      }, 300);
    })
  }
  useEffect(() => {
    if (billId && !selectedData) {
      setSelectedData({
        label: billId,
        value: billId,
        data: null,
      })
      GET(`/bill/${billId}`, {}, true).then(({ data }) => {
        setSelectedData({
          label: billId,
          value: billId,
          data,
        })
      })
    }
  }, [billId])


  return <><Row>
    <Col md={5}>
      <Controller
        control={control}
        name="billId"
        render={({ onChange, name, ref, value }) => (
          <AsyncSelect
            inputRef={ref}
            name={name}
            placeholder="Gõ tìm mã đơn"
            loadOptions={onSearchBill}

            value={selectedData}
            defaultOptions={selectedData ? [selectedData] : []}
            onChange={(option) => {
              onChange(option.value);
              setSelectedData(option)
            }}
          />
        )}
      />
    </Col>
    {selectedData?.data ? <Col md={7}>
      KH/NCC: {selectedData.data?.customer?.name}
    </Col> : <></>}

  </Row>
    <Row>
      <ErrorMessage
        errors={errors}
        name="billId"
        render={({ message }) => (
          <span className="invalid">{message}</span>
        )}
      />
    </Row>
  </>
}

export default SearchBill